'use client';

import { Link } from '@/components/link/Link';
import type { NavLink } from '../types';

type NavLinkListProps = {
  links?: NavLink[];
  onNavigate?: () => void;
};

/**
 * The link list used by both columns of a mega-menu panel.
 *
 * Every list stays in the server-rendered markup even while its panel is
 * hidden, so the destinations are reachable to a crawler and to assistive
 * technology without a pointer interaction first.
 */
export const NavLinkList = ({ links, onNavigate }: NavLinkListProps) => {
  if (!links?.length) return null;

  return (
    <ul className="mt-2 flex flex-col gap-5 sm:pl-2">
      {links.map((link) => (
        <li key={`${link.title}-${link.slug}`}>
          <Link
            variant="tertiary"
            title={link.title}
            className="!pl-0 !font-[400] !text-brand-800"
            href={link.slug}
            onClick={onNavigate}
          >
            {link.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default NavLinkList;
